// extracted by mini-css-extract-plugin
module.exports = {"AdSlotSticky":"uk_a vh_bi vh_nb","AdSlotSticky__slot":"uk_b vh_cw","AdSlotSticky__slot--left":"uk_c vh_re","AdSlotSticky__slot--right":"uk_e vh_rf"};